const ChevronDown = () => (
  <svg height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path stroke="#0500FF" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m19 9-7 7-7-7" />
  </svg>
);

export { ChevronDown };
